import { Helmet } from "react-helmet"
import { LoadingSpinner } from "../components/BaseComponents"
import PageTemplate from "../components/BaseComponents/PageTemplate/PageTemplate"
import { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { userContext } from "../context/UserContext";
import routes from "../components/Router/routes";
import { useAppDispatch } from "../redux/hooks/reduxHooks";
import { ACCOUNTINGPERIODS_RESET } from "../redux/slices/accountingPeriodsSlice";

function ClearAssumedCompany() {

    const { setCompanyAssumption, userData } = useContext(userContext)
    const navigate = useNavigate();
    const dispatch = useAppDispatch();

    useEffect(() => {
        // Clear accounting periods state when clearing company assumption
        dispatch(ACCOUNTINGPERIODS_RESET())
        setCompanyAssumption && setCompanyAssumption(null)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        if(!userData?.access?.assumedCompanyType) {
            // Navigate directly to role-based dashboard to avoid LandingPage redirect loop
            if (userData?.role === 'admin') {
                navigate(routes.adminDashboard.path, { replace: true })
            } else {
                navigate(routes.companyDashboard.path, { replace: true })
            }
        }
    }, [userData?.access?.assumedCompanyType, userData?.role, navigate])

	return (
		<PageTemplate testid='add-accounting-periods-main'>
			<Helmet>
				<title>Loading</title>
			</Helmet>
            <LoadingSpinner />
        </PageTemplate>
	)
}

export default ClearAssumedCompany
